import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import FloatingAssessmentCTA from '../../components/ui/FloatingAssessmentCTA';
import HeroSection from './components/HeroSection';
import RealityCheckSection from './components/RealityCheckSection';
import TestimonialsCarousel from '../../components/testimonials/TestimonialsCarousel';
import TransformationSection from './components/TransformationSection';
import TrustSignalsSection from './components/TrustSignalsSection';
import FinalCTASection from './components/FinalCTASection';
import AboutMiriSection from './components/AboutMiriSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>¿Cuál es tu Edad Real? - Evaluación Gratuita de Salud</title>
        <meta name="description" content="Descubre tu edad biológica real con nuestra evaluación gratuita. Más de 15,000 mujeres ya conocen su verdad sobre el envejecimiento." />
      </Helmet>
      <Header />
      <FloatingAssessmentCTA />
      <main className="pt-20">
        <HeroSection />
        <RealityCheckSection />
        <TransformationSection />
        <TestimonialsCarousel autoplay={true} />
        <TrustSignalsSection />
        <FinalCTASection />
        <AboutMiriSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;